<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <div class="mt-4 text-center">
      <BaseCard heading="Nueva Programación Menú">
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col lg="4" md="4" sm="12" class="col-12">
                <v-select
                  v-model="cliente"
                  :rules="[() => !!cliente || 'Campo Requerido']"
                  :items="clienteOpciones"
                  label="Seleccione Cliente"
                >
                </v-select>
              </v-col>
              <v-col lg="4" md="4" sm="12" class="col-12">
                <v-select
                  v-model="sectorespadre"
                  :rules="[() => !!sectorespadre || 'Campo Requerido']"
                  :items="sectorespadreOpciones"
                  label="Seleccione Sector"
                >
                </v-select>
              </v-col>
              <v-col lg="4" md="4" sm="12" class="col-12">
                <v-select
                  v-model="comedor"
                  :rules="[() => !!comedor || 'Campo Requerido']"
                  :items="comedorOpciones"
                  label="Seleccione un comedor"
                >
                </v-select>
              </v-col>
              <v-col
                lg="10"
                md="10"
                sm="12"
                class="col-12"
                v-if="sectorespadre != '' && cliente != '' && comedor != '' ? true : false"
              >
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ attrs }">
                    <v-combobox
                      v-model="dates"
                      multiple
                      small-chips
                      :rules="[required]"
                      label="Seleccione Fechas"
                      prepend-icon="fas fa-calendar-alt"
                      readonly
                      clearable
                      @click="dataFechas"
                      v-bind="attrs"
                    >
                      <template v-slot:selection="{ item }">
                        <v-chip close @click:close="eliminar(item, 'F')">
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </template>
                  <v-date-picker
                    :min="nowDate"
                    v-model="dates"
                    multiple
                    no-title
                    scrollable
                    color="primary"
                    :allowed-dates="allowedDates"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col lg="1" md="1" sm="1" class="col-12 d-flex align-center" v-if="dates.length > 0 ? true : false">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="openDialog()">
                      <v-icon small dark>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <span>Seleccion de Platos</span>
                </v-tooltip>
              </v-col>
              <v-col lg="6" md="6" sm="12" class="col-12" v-if="dates.length > 0 ? true : false">
                <v-checkbox v-model="programareleccion" label="Programar para elección de menú"></v-checkbox>
              </v-col>
              <v-col lg="6" md="6" sm="12" class="col-12" v-if="programareleccion">
                <v-menu
                  ref="menuRange"
                  :close-on-content-click="false"
                  v-model="menuRange"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      v-model="dateRangeText"
                      label="Rango Fechas"
                      prepend-icon="mdi-calendar"
                      readonly
                      @click="dataFechasRange"
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    :min="nowDate"
                    :max="fechasBloqueadasRange"
                    v-model="datesRange"
                    range
                    no-title
                    scrollable
                    color="primary"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <!--
              <v-col lg="6" md="6" sm="12" class="col-12">
                <v-combobox
                  v-model="planillas"
                  :rules="[required]"
                  :items="planillasOpciones"
                  label="Seleccione Planillas"
                  multiple
                >
                  <template v-slot:selection="{ item }">
                    <v-chip close @click:close="eliminar(item.value, 'P')">
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              -->
              <v-col lg="10" md="10" sm="10" class="col-12" v-if="dates.length > 0 ? true : false">
                <v-select
                  v-model="desayunos"
                  :rules="[required]"
                  :items="desayunosOpciones"
                  label="Desayunos Asignados"
                  no-data-text="Sin datos"
                  multiple
                >
                  <template v-slot:selection="{ item }">
                    <v-chip close @click:close="eliminar(item.value, 'D')">
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col lg="10" md="10" sm="10" class="col-12" v-if="dates.length > 0 ? true : false">
                <v-select
                  v-model="almuerzos"
                  :rules="[required]"
                  :items="almuerzosOpciones"
                  label="Almuerzos Asignados"
                  no-data-text="Sin datos"
                  multiple
                  small-chips
                >
                  <template v-slot:selection="{ item }">
                    <v-chip close @click:close="eliminar(item.value, 'A')">
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col lg="10" md="10" sm="10" class="col-12" v-if="dates.length > 0 ? true : false">
                <v-select
                  v-model="cenas"
                  :rules="[required]"
                  :items="cenasOpciones"
                  no-data-text="Sin datos"
                  label="Cenas Asignados"
                  multiple
                  small-chips
                >
                  <template v-slot:selection="{ item }">
                    <v-chip close @click:close="eliminar(item.value, 'C')">
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <PlatosListado
                ref="platosLista"
                :selected="false"
                :dialog="dialog"
                @asignarPlatos="asignarPlatos($event)"
                @cancelar="cancelarDialogo()"
              ></PlatosListado>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelar()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </BaseCard>
      <div v-if="showLoading" class="progress-background">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-snackbar v-model="snackbar" timeout="3000">
        {{ text }}
        <v-btn color="info" text @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment';
import ProgramacionMenuService from '../services/ProgramacionMenuService';
export default {
  name: 'GestionProgramacionMenuFormulario',
  components: {
    PlatosListado: () => import('./PlatosListado')
  },
  data: () => ({
    valid: false,
    snackbar: false,
    text: '',
    datesRange: [],
    showLoading: false,
    nowDate: new Date().toISOString().slice(0, 10),
    dialog: false,
    planillas: [{ text: 'test', value: 'test' }],
    planillasOpciones: [],
    desayunos: [],
    desayunosOpciones: [],
    almuerzos: [],
    almuerzosOpciones: [],
    cenas: [],
    data: [],
    cenasOpciones: [],
    dates: [],
    dateRangeText: '',
    menu: false,
    menuRange: false,
    cliente: '',
    clienteOpciones: [],
    fechasBloqueadas: [],
    fechasBloqueadasRange: [],
    programacionMenuService: null,
    //-------------------------------------------
    sectorespadre: '',
    sectorespadreOpciones: [],
    comedor: '',
    comedorOpciones: [],
    programareleccion: false,
    //-------------------------------------------
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Gestión de Programacion de Menu',
        disabled: true
      },
      {
        text: 'Lista de Programacion de Menu',
        disabled: true
      },
      {
        text: 'Agregar',
        disabled: true
      }
    ]
  }),
  computed: {},
  watch: {
    datesRange() {
      return (this.dateRangeText = this.datesRange.join(' ~ '));
    },
    programareleccion() {
      this.datesRange = [];
    },
    dates() {
      this.valida(false);
    },
    comedor() {
      this.valida(true);
    },
    async sectorespadre() {
      await this.iniciaComedor();
      this.valida(true);
    },
    cliente() {
      this.valida(true);
    }
  },
  methods: {
    allowedDates(val) {
      if (this.fechasBloqueadas.indexOf(val) !== -1) {
        return false;
      } else {
        return true;
      }
    },
    valida(aux) {
      if (aux) {
        this.dates = [];
      }
      if (this.dates.length == 0) {
        this.desayunos = [];
        this.desayunosOpciones = [];
        this.almuerzos = [];
        this.almuerzosOpciones = [];
        this.cenas = [];
        this.cenasOpciones = [];
      }
    },
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return 'Campo Requerido.';
      }
      return !!value;
    },
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    },
    openDialog() {
      this.dialog = true;
    },
    cancelarDialogo() {
      this.dialog = false;
    },
    async iniciaPlanilla() {
      const res = await this.programacionMenuService.get().execResource('planillas', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        this.planillasOpciones.push({ text: 'TODOS', value: '' });
        res.forEach((element) => {
          this.planillasOpciones.push({ text: element.idplanilla, value: element.idplanilla });
        });
      }
    },
    async iniciaCliente() {
      const res = await this.programacionMenuService.get().execResource('clientes', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.clienteOpciones.push({ text: element.razonsocial, value: element.idcliente });
        });
        this.cliente = this.clienteOpciones[0].value;
      }
    },
    async iniciaSectores() {
      const res = await this.programacionMenuService.get().execResource('sector', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.sectorespadreOpciones.push({ text: element.descripcion, value: element.idsectorpadre });
        });
        this.sectorespadre = this.sectorespadreOpciones[0].value;
      }
    },
    async iniciaComedor() {
      this.open();
      const res = await this.programacionMenuService.get().execResource('comedor', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sectorespadre
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.comedorOpciones.push({ text: element.comedor, value: element.comedor });
        });
        this.comedor = this.comedorOpciones[0].value;
      }
      this.close();
    },
    async asignarPlatos(val) {
      this.desayunosOpciones = [];
      this.almuerzosOpciones = [];
      this.cenasOpciones = [];
      val.forEach((element) => {
        if (element.desayuno == 1) {
          this.desayunosOpciones.push({
            text: element.descripcioncorta,
            value: element.idplato
          });
        }
        if (element.almuerzo == 1) {
          this.almuerzosOpciones.push({
            text: element.descripcioncorta,
            value: element.idplato
          });
        }
        if (element.cena == 1) {
          this.cenasOpciones.push({
            text: element.descripcioncorta,
            value: element.idplato
          });
        }
      });
      this.desayunosOpciones.forEach((element) => {
        this.desayunos.push(element.value);
      });
      this.almuerzosOpciones.forEach((element) => {
        this.almuerzos.push(element.value);
      });
      this.cenasOpciones.forEach((element) => {
        this.cenas.push(element.value);
      });
      // this.desayunos = [...this.desayunosOpciones];
      // this.almuerzos = [...this.almuerzosOpciones];
      // this.cenas = [...this.cenasOpciones];
      this.cancelarDialogo();
    },
    eliminar(val, tipo) {
      console.log(this.desayunos, val);
      switch (tipo) {
        case 'D':
          var index = this.desayunos.findIndex((x) => x === val);
          if (index != -1) {
            this.desayunos.splice(index, 1);
          }
          break;
        case 'A':
          var index1 = this.almuerzos.findIndex((x) => x === val);
          if (index1 != -1) {
            this.almuerzos.splice(index1, 1);
          }
          break;
        case 'C':
          var index2 = this.cenas.findIndex((x) => x === val);
          if (index2 != -1) {
            this.cenas.splice(index2, 1);
          }
          break;
        case 'P':
          var index3 = this.planillas.findIndex((x) => x === val);
          if (index3 != -1) {
            this.planillas.splice(index3, 1);
          }
          break;
        case 'F':
          var index4 = this.dates.findIndex((x) => x === val);
          if (index4 != -1) {
            this.dates.splice(index4, 1);
          }
          break;
      }
    },
    cancelar() {
      this.$router.push({ path: '/comedor/gestion_programacion_menu' });
    },
    async guardar() {
      if (this.$refs.form.validate()) {
        this.open();
        /* this.planillas.forEach((element) => {
          aux4.push(element.value);
        }); */
        const res = await this.programacionMenuService.post().execResource('insertarprogramacion', {
          idempresa: localStorage.getItem('emp'),
          idusuario: localStorage.getItem('user'),
          idcliente: this.cliente,

          programareleccion: this.programareleccion ? 1 : 0,
          comedor: this.comedor,
          inicioprogeleccion:
            Date.parse(this.datesRange[0]) < Date.parse(this.datesRange[1]) ? this.datesRange[0] : this.datesRange[1],
          finprogeleccion:
            Date.parse(this.datesRange[1]) > Date.parse(this.datesRange[0]) ? this.datesRange[1] : this.datesRange[0],

          planillas: ['test'],
          almuerzos: this.almuerzos,
          cenas: this.cenas,
          desayunos: this.desayunos,
          fechas: this.dates
        });
        if (res.status) {
          this.text = res.message;
          this.snackbar = true;
          this.dates = [];
          this.programareleccion = false;
          this.datesRange = [];
        } else {
          this.text = res.message[0].error;
          this.snackbar = true;
        }
      }
      this.close();
    },
    async dataFechas() {
      this.fechasBloqueadas = [];
      this.open();
      const res = await this.programacionMenuService.get().execResource('fechas', {
        idempresa: localStorage.getItem('emp'),
        idcliente: this.cliente,
        comedor: this.comedor
      });

      if (res.length > 0) {
        res.forEach((element) => {
          this.fechasBloqueadas.push(element.fecha);
        });
      } else {
        this.fechasBloqueadas = [];
      }
      this.$refs.menu.isActive = true;
      this.close();
    },
    dataFechasRange() {
      this.fechasBloqueadasRange = [];
      let fechamenor = this.dates[0];
      this.dates.forEach((element) => {
        if (Date.parse(element) < Date.parse(fechamenor)) {
          fechamenor = element;
        }
      });
      this.fechasBloqueadasRange = moment(fechamenor)
        .subtract(1, 'd')
        .format('YYYY-MM-DD');
    }
  },
  async mounted() {
    this.programacionMenuService = this.$httpService(new ProgramacionMenuService(), this);
    this.open();
    await this.iniciaCliente();
    //await this.iniciaPlanilla();
    await this.iniciaSectores();
    this.close();
  }
};
</script>
